import { useEffect, useState } from "react";
import { Trophy, Crown } from "lucide-react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";

const MEDAL = ["#F5B301", "#A8B3AE", "#C9733A"];
const daysLeft = (iso) => Math.max(0, Math.ceil((new Date(iso).getTime() - Date.now()) / 86400000));

export const InviteLeaderboard = () => {
  const { t } = useApp();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/referrals/leaderboard").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const needed = d.top[2] ? Math.max(1, d.top[2].friends - d.my_friends + 1) : 1;
  return (
    <div className="space-y-3 rounded-3xl bg-[#0D3B2B] p-5 text-white" data-testid="invite-leaderboard">
      <div className="flex items-start justify-between gap-2">
        <div>
          <p className="flex items-center gap-1 text-xs font-bold uppercase tracking-widest text-[#9BE3BF]"><Trophy className="h-4 w-4" />{t("Top inviters this month")}</p>
          <p className="mt-1 text-sm text-white/80">{t("Friends who complete their first pickup count.")} {daysLeft(d.ends_at)} {t("days left")}</p>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2" data-testid="invite-prizes">
        {d.prizes.map((p, i) => (
          <div key={i} className="rounded-2xl bg-white/10 p-2 text-center">
            <Crown className="mx-auto h-5 w-5" style={{ color: MEDAL[i] }} />
            <p className="font-display text-lg font-extrabold">{p}</p><p className="text-[10px] text-white/70">{t("points")} · #{i + 1}</p>
          </div>
        ))}
      </div>
      <div className="space-y-1.5" data-testid="invite-top-list">
        {d.top.map((r) => (
          <div key={r.rank} className={`flex items-center justify-between rounded-xl px-3 py-2 text-sm ${r.me ? "bg-[#E05C3A]" : "bg-white/5"}`} data-testid={`invite-rank-${r.rank}`}>
            <span className="flex items-center gap-2"><b className="w-5" style={{ color: MEDAL[r.rank - 1] || "#fff" }}>#{r.rank}</b>{r.me ? t("You") : r.name}<span className="text-[11px] text-white/60">{t(r.customer_type)}</span></span>
            <b>{r.friends}</b>
          </div>
        ))}
        {!d.top.length && <p className="rounded-xl bg-white/5 p-3 text-sm text-white/80" data-testid="invite-empty">{t("No one has made it to the board yet this month. Invite one friend and you could be #1!")}</p>}
      </div>
      <p className="rounded-xl bg-white/10 p-3 text-sm" data-testid="invite-my-status">
        {d.my_rank && d.my_rank <= 3 ? `${t("You're")} #${d.my_rank}! ${t("Keep inviting to hold your spot.")}`
          : `${t("You have")} ${d.my_friends}. ${needed} ${t("more friend(s) to reach the top 3.")}`}</p>
      {d.last_winners.length > 0 && <p className="text-[11px] text-white/60" data-testid="invite-last-winners">{t("Last month's winners")}: {d.last_winners.map((w) => `#${w.rank} ${w.name}`).join(" · ")}</p>}
    </div>
  );
};
